import React, { useMemo } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import Pane from 'components/Common/Pane'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import ValuePropositionItems from 'home/components/ValuePropositionBanner/ValuePropositionItems'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { getHotelValueContentSection } from './getHotelValueContentSection'
import { useIntl } from 'react-intl'

const StyledLayoutContainer = styled(LayoutContainer)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
`

function HotelValuePropositionBanner() {
  const intl = useIntl()
  const values = useMemo(() => getHotelValueContentSection(intl).filter(value => value.show), [intl])
  return (<Pane>
    <StyledLayoutContainer>
      <VerticalSpacer gap={20}>
        <Heading variant="heading2">{intl.formatMessage({
          id: 'RhBlB8dhq2ePxCQrfkj_',
          defaultMessage: 'Why you should book with us',
          description: 'Section heading for why book with us section on the offer types landing page',
        })}
        </Heading>
        <ValuePropositionItems values={values} />
      </VerticalSpacer>
    </StyledLayoutContainer>
  </Pane>)
}

export default React.memo(HotelValuePropositionBanner)
